 <template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Waiting Requests</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
    >
    </o-list-toolbar>

    <BTable
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header"
      @row-selected="onRowSelected"
      :selectable="selected.selectable"
      :key="selected.selectable"
      :busy="working"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template #top-row="{ columns, fields }" v-if="filterRow">
        <filter-cell
          :key="field.key"
          v-for="field in fields"
          :field="field"
          :schema="schemaModel"
          :options="filter_row_options"
          :qbe="list_options.qbe"
          @filter="filter_changed"
        />
      </template>
      <template #cell(completed_date)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'completed_date'"
        >
          <date-display
            :value="item.completed_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template #cell(created_date)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template #cell(description)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'description'"
        >
          <default-display
            :value="item.description"
            default-value="-"
          ></default-display>
        </o-link-cell> </template
      ><template
        #cell(instance__form_template_version__form_template_versions__name)="{
          index,
          item,
        }"
      >
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="
            first_column_key ===
            'instance__form_template_version__form_template_versions__name'
          "
        >
          <default-display
            :value="
              item.instance__form_template_version__form_template_versions__name
            "
            default-value="-"
          ></default-display>
        </o-link-cell>
      </template>
      <template #cell(role__name)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'role__name'"
        >
          <default-display
            :value="item.role__name"
            default-value="-"
          ></default-display>
        </o-link-cell>
      </template>
      <template #cell(instance)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'instance'"
        >
          <lookup-display
            :list="optionFormEntryItemsById"
            :value="item.instance"
            display-field="other_name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template #cell(modified_date)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template #cell(role)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'role'"
        >
          <number-display :value="item.role" :decimals="0" />
        </o-link-cell>
      </template>
      <template #cell(started_date)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'started_date'"
        >
          <date-display
            :value="item.started_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template #cell(state)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'state'"
        >
          <default-display
            :value="item.state"
            default-value="-"
          ></default-display>
        </o-link-cell>
      </template>
      <template #cell(who)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'who'"
        >
          <lookup-display
            :list="optionUserItemsById"
            :value="item.who"
            display-field="username"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>

      <template #cell(instance__created_user)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'instance__created_user'"
        >
          <lookup-display
            :list="optionUserItemsById"
            :value="item.instance__created_user"
            display-field="username"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>

      <template #cell(instance__created_user__username)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'instance__created_user__username'"
        >
          <default-display
            :value="item.instance__created_user__username"
            default-value="-"
          ></default-display>
        </o-link-cell> </template>

      <template #cell(instance__submitted_user)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'instance__submitted_user'"
        >
          <lookup-display
            :list="optionUserItemsById"
            :value="item.instance__submitted_user"
            display-field="username"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template #cell(instance__submitted_user__username)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'instance__submitted_user__username'"
        >
          <default-display
            :value="item.instance__submitted_user__username"
            default-value="-"
          ></default-display>
        </o-link-cell> </template>
      <template #cell(instance__submitted_date)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'instance__submitted_date'"
        >
          <date-display
            :value="item.instance__submitted_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template #cell(instance__created_date)="{ index, item }">
        <o-link-cell
          :to="{
            name: 'form_entry.edit',
            params: { id: item.instance, state: item.id },
          }"
          :when="first_column_key === 'instance__created_date'"
        >
          <date-display
            :value="item.instance__created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'form_entry_workflow_state.create' }"
          >create a new item</router-link
        >
      </template>
    </BTable>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import { BTable } from "bootstrap-vue";
import {
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "@/vue-ocom/mixins";
import FetchAndUseCodeModMixin from "@/vue-ocom/mixins/FetchAndUseCodeModMixin";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "@/vue-ocom/schema/schema_utils";
import { cleanUpModel } from "@/vue-ocom/schema/schema_vuetify.js";
import schema from "../../schema/index.js";

import OListToolbar from "@/vue-ocom/components/list/OListToolbar.vue";
import OListPaging from "@/vue-ocom/components/list/OListPaging.vue";
import DefaultDisplay from "@/vue-ocom/components/display/DefaultDisplay.vue";
import DateDisplay from "@/vue-ocom/components/display/DateDisplay.vue";
import NumberDisplay from "@/vue-ocom/components/display/NumberDisplay.vue";
import BooleanDisplay from "@/vue-ocom/components/display/BooleanDisplay.vue";
import LookupDisplay from "@/vue-ocom/components/display/LookupDisplay.vue";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad.vue";
import EmailIcon from "vue-material-design-icons/Email.vue";
import LinkIcon from "vue-material-design-icons/Link.vue";
import FilterCell from "@/vue-ocom/components/list/filter/FilterCell.vue";

export default {
  components: {
    BTable,
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
    FilterCell,
  },
  mixins: [
    CreateListPageMixin("FormEntryWorkflowState", "form_entry_workflow_state"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("FormEntryWorkflowState"),
    FetchAndUseCodeModMixin(["User"]),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.FormEntryWorkflowState,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.FormEntryWorkflowState),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        {
          name: "Assigned to Me",
          code: "assigned",
          options: { offset: 0, sort: "created_date" },
        },
          {
          name: "My Completed Requests",
          code: "my_completed_entries",
          options: { offset: 0, sort: "created_date" },
        },
        {
          name: "My Requests I am Waiting for",
          code: "my_waiting_entries",
          options: { offset: 0, sort: "created_date" },
        },
        {
          name: "All Waiting",
          code: "all_waiting",
          options: { offset: 0, sort: "created_date" },
        },
        {
          name: "All Completed",
          code: "all_completed",
          options: { offset: 0, sort: "created_date" },
        },
        {
          name: "All",
          code: "all",
          options: { offset: 0, sort: "created_date" },
        },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
    };
  },
  computed: {
    options() {
      return {
        User: {
          options: this.optionUserItems,
          textField: "username",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "instance__form_template_version__form_template_versions__name",
        "description",
        "role__name",
        "started_date",
        "instance__created_date",
        "instance__created_user__username",
        "instance__submitted_date",
        "instance__submitted_user__username",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
    filter_row_options() {
      // Options for the FilterRow components
      return {
        id: false /*No filter for this field */,
        instance: {
          options: this.optionFormEntryItems,
          loading: this.optionFormEntryWorking,
          "text-field": "other_name",
          "value-field": "id",
          "sort-field": "other_name",
          "blank-option-text": "",
        },
        state: {},
        description: {},
        role: {},
        instance__created_user: {
          options: this.optionUserItems,
          loading: this.optionUserWorking,
          "text-field": "username",
          "value-field": "id",
          "sort-field": "username",
          "blank-option-text": "",
        },
        instance__submitted_user: {
          options: this.optionUserItems,
          loading: this.optionUserWorking,
          "text-field": "username",
          "value-field": "id",
          "sort-field": "username",
          "blank-option-text": "",
        },
        who: {
          options: this.optionUserItems,
          loading: this.optionUserWorking,
          "text-field": "username",
          "value-field": "id",
          "sort-field": "username",
          "blank-option-text": "",
        },
        created_date: {},
        modified_date: {},
        completed_date: {},
        started_date: {},
      };
    },
  },
};
</script>
